/* jshint esnext: true */

/**
 * The Game scene.
 *
 * This is what powers the game itself.
 */
class SceneController extends Phaser.Scene {

	constructor() {

		super( { key: 'SceneController' } );

	}

	create() {

		gameTimer.create( this );

	}

	update() {

		gameTimer.update();

	}

}